const spaceAndSize: {
  [p: string]: string | number | boolean
  [p: number]: string | number | boolean
} = {
  0: 0,
  '0-5': '0.125rem',
  1: '0.25rem',
  '1-5': '0.375rem',
  2: '0.5rem',
  '2-5': '0.625rem',
  3: '0.75rem',
  '3-5': '0.875rem',
  4: '1rem',
  '4-5': '1.125rem',
  5: '1.25rem',
  6: '1.5rem',
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  '9-5': '2.375rem',
  10: '2.5rem',
  '10-5': '2.625rem',
  11: '2.75rem',
  12: '3rem',
  14: '3.5rem',
  16: '4rem',
  18: '4.5rem',
  20: '5rem',
  24: '6rem',
  25: '6.25rem', // 100px
  28: '7rem',
  32: '8rem',
  34: '8.5rem',
  36: '9rem',
  40: '10rem',
  44: '11rem',
  48: '12rem',
  52: '13rem',
  56: '14rem',
  60: '15rem'
}

export const space = {
  ...spaceAndSize
}

export const sizes = {
  ...spaceAndSize,
  full: '100%',
  xs: '16rem',
  sm: '20rem',
  md: '24rem',
  lg: '32rem',
  xl: '36rem',
  '2xl': '42rem'
}

export const media = {
  xs: '(min-width: 440px)',
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  '2xl': '(min-width: 1536px)'
}

export const fontSizes = {
  '2xs': '0.65rem',
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '2rem',
  '4xl': '2.5rem',
  '5xl': '3.25rem',
  '6xl': '6rem'
}

export const lineHeights = {
  '2xs': '0.9rem',
  xs: '1rem',
  sm: '1.25rem',
  md: '1.5rem',
  lg: '1.75rem',
  xl: '1.75rem',
  '2xl': '2rem',
  '3xl': '2.25rem',
  '4xl': '2.5rem',
  '5xl': '3.875rem',
  '6xl': '7.5rem'
}

export const letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0em',
  wide: '0.025em'
}
